import {createReducer} from '../../base/fsa/createReducer';
import {initialSettingsState} from './state';
import {setConnectedWifiAction, setSettingsAction} from './actions';

export const settingsReducer = createReducer(initialSettingsState, handle => [
    handle(setSettingsAction, (state, action) => {
        return {
            ...action.payload,
        };
    }),
    handle(setConnectedWifiAction, (state, action) => {
        return {
            ...state,
            connectedWifi: action.payload
        }
    })
])
